import React from 'react';
import {Select} from "antd";
import {QueryKey} from "@tanstack/react-query";
import {useCommonUseQuery} from "../../../../../Common/hooks/rest/ReacQueryHook";
import {procAdminService} from "../../../../../Common/util/ProcService";
import {TB_STORAGE_MGR} from "../../index/StorageMgr/data/StorageWizMgrData";

interface Option {
    value: string | number;
    label: string;
    children?: Option[];
}

export interface SelectDeptProps{
    onChangeValue:(value:string)=>void,
}



function SelectArchive(props:SelectDeptProps)
{
    const {onChangeValue} = props;
    const serviceCode:string       =   process.env.REACT_APP_SERVICE_NAME as string;
    const queryKey:QueryKey =   [`SelectArchive`];
    const { data} = useCommonUseQuery<TB_STORAGE_MGR[]>(
        queryKey,
        () =>procAdminService<TB_STORAGE_MGR[]>("post", `${serviceCode}ADS15`, null));

    function getOption(input:TB_STORAGE_MGR[]):{ label: string | null; value: string | null }[]
    {
        let options: { label: string | null; value: string | null }[] = [{
            value:"ALL", label:"전체"
        }]
        return options.concat( input.map(data => ({value: data.storageName, label: data.storageName})) );
    }

    const options: { label: string | null; value: string | null }[] = data ? getOption(data) : [{
            value: 'Loading',
            label: 'Loading...',
        },
    ];

    return (

        <Select
            style={{width:"150px", marginRight:"10px", marginLeft:"10px"}}
            onChange={(value, selectedOptions) => {
                const selectedValue = Array.isArray(value) ? value.join(', ') : value;
                onChangeValue(selectedValue); // 문자열 또는 문자열 배열
            }}
            options={options}
            placeholder={"아카이빙선택"}
        />
    );

};

export default SelectArchive;
